import {
  Box,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Icon,
  IconButton,
  Text,
} from '@chakra-ui/react'
import { ChevronRight } from 'lucide-react'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

import {
  Dialog,
  DialogDrawer,
  DialogTrigger,
} from '@/components/shared/bundles/Drawer'
import { ViewVistaDisplayer } from '@/features/equipamentos/Vista/view-vista-displayer'
import { SelectVistaProductDialog } from '@/features/equipamentos/VistaProduct/select-vistaProduct-dialog'
import { Product } from '@/services/backend/config/entities'
import { Repository } from '@/services/repository'

interface Props {
  callId: number
  equipmentId: string
  onChange: () => void
}

export default function Component({ callId, equipmentId, onChange }: Props) {
  const { data } = useQuery(
    ['CreateCallProductDialog', { equipmentId }],
    async () => {
      return await Repository.Entity.Vista.FindByEquipmentId({ equipmentId })
    },
  )

  const sortedData = (data || []).sort((a, b) => (a.name > b.name ? 1 : -1))

  async function createHandler(data: Product) {
    try {
      await Repository.Entity.CallProduct.Create({ callId, productId: data.id })
      toast.success(
        <Box>
          <Text fontWeight="bold" fontSize="xs">
            {data.sku}
          </Text>
          <Text fontSize="sm" color="gray.400">
            {data.name}
          </Text>
          <Text mt={4}>Adicionado com sucesso!</Text>
        </Box>,
      )
      onChange()
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  return (
    <DialogDrawer>
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Selecione uma vista</DrawerHeader>
        <DrawerBody>
          {sortedData?.map((ea) => {
            return (
              <Box key={ea.id} mb={4} pr={4}>
                <ViewVistaDisplayer data={ea}>
                  <Dialog>
                    <DialogTrigger>
                      <IconButton
                        aria-label="Selecionar"
                        icon={<Icon as={ChevronRight} />}
                        colorScheme="primary"
                      />
                    </DialogTrigger>
                    <SelectVistaProductDialog
                      vistaId={ea.id}
                      onSelect={(data) => createHandler(data.Product)}
                    />
                  </Dialog>
                </ViewVistaDisplayer>
              </Box>
            )
          })}
        </DrawerBody>
      </DrawerContent>
    </DialogDrawer>
  )
}
